import { PageHero } from "@/components/common/PageHero";
import { Vision } from "@/components/home/Vision";
import { Philosophy } from "@/components/home/Philosophy";
import { Ecosystem } from "@/components/home/Ecosystem";
import { Stats } from "@/components/home/Stats";
import { FinalCta } from "@/components/home/FinalCta";
import { IMAGES } from "@/lib/content";
import { useSeo } from "@/lib/seo";

export default function Groupe() {
  useSeo({
    title: "Le Groupe — Qui est Losta Group | Holding France & Suisse",
    description:
      "Losta Group est une holding d'acquisition et de développement d'entreprises. Découvrez notre vision, notre philosophie et notre écosystème franco-suisse.",
    path: "/groupe",
  });
  return (
    <>
      <PageHero
        eyebrow="Le Groupe"
        lines={["Construire le réseau", "de référence de nos métiers."]}
        sub="Une holding sérieuse, ambitieuse et entrepreneuriale qui construit progressivement un groupe national en France et en Suisse."
        image={IMAGES.swiss}
      />
      <Vision />
      <Philosophy />
      <Ecosystem />
      <Stats />
      <FinalCta />
    </>
  );
}
